import React, { Component } from 'react';
import { Button, TextField, SelectField, DropdownMenu, ListItem } from 'react-md';

import ZSelectField from '../Utility/ZSelectField';

export default class MetricsTopBar extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    render() {
        let outerStyle = {};
        let normalStyle = {};

        if (!this.props.isScrollTop) {
            outerStyle.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.16), 0 3px 3px rgba(0, 0, 0, 0.23)';
        }


        let metricOptionStrings = this.props.screenContext.locationList.map((obj) => { return obj.name });
        let metricOptionDefaultValue = null;
        let metricOptionJsx = null;
        if (this.props.screenContext.locationList.length > 0 && this.props.screenContext.mode === 'main') {
            metricOptionDefaultValue = this.props.screenContext.selectedLocation.name;
            metricOptionJsx = (
                <ZSelectField
                    id="stackup-top-bar-select-field"
                    placeholder=""
                    defaultValue={this.props.screenContext.selectedLocation.name}
                    className="md-cell stackup-top-bar-selector"
                    menuItems={metricOptionStrings}
                    position={SelectField.Positions.BELOW}
                    simplifiedMenu={true}
                    stripActiveItem={false}
                    onChange={this.props.changeTopSelector}
                    value={this.props.screenContext.selectedLocation.name}
                    activeColor="rgba(0, 126, 181, 1)"
                    isBlocked
                />
            );
        }

        if (this.props.screenContext.mode === 'intro') {
            normalStyle.opacity = '0';
        }

        return (
            <div className="stackup-top-bar-outer" style={outerStyle}>
                <div className="stackup-top-bar-normal-container" style={normalStyle}>
                    <div className="stackup-top-bar-menu-button material-icons" onClick={this.props.toggleNav}>menu</div>
                    <div className="stackup-top-bar-selector-container">
                        <div className="stackup-top-bar-title">Stack-Up</div>
                        {metricOptionJsx}
                    </div>
                </div>
            </div>
        );
    }
}
